// extracted by mini-css-extract-plugin
export default {"container":"SelectPackageView_container__86jbB"};